import React from "react";
import { FormikProps, Field } from "formik";
import { InputColumn, InputText, InputValidation } from "src/components/Inputs";

const Form: React.FC<FormikProps<DepartmentFormValues>> = ({ errors }) => {
  return (
    <>
      <InputColumn label="Nome">
        <Field name="name" component={InputText} required={true} />
        <InputValidation message={errors.name} />
      </InputColumn>
    </>
  );
};

export default Form;
